import { db } from "../client";

export async function getJobs({
	limit,
	offset,
	query,
	status,
	organizationId,
	startDate,
	endDate,
	planType,
}: {
	limit: number;
	offset: number;
	query?: string;
	status?: string;
	organizationId?: string;
	startDate?: string;
	endDate?: string;
	planType?: "free" | "paid";
}) {
	// Build the where clause
	const whereClause: any = {
		isDeleted: false,
		...(query && {
			OR: [
				{
					title: {
						contains: query,
						mode: "insensitive",
					},
				},
				{
					description: {
						contains: query,
						mode: "insensitive",
					},
				},
				{
					user: {
						email: {
							contains: query,
							mode: "insensitive",
						},
					},
				},
				{
					organization: {
						name: {
							contains: query,
							mode: "insensitive",
						},
					},
				},
			],
		}),
		...(status && { status: status as any }),
		...(organizationId && { organizationId }),
		...(startDate && {
			createdAt: {
				gte: new Date(`${startDate}T00:00:00.000Z`),
				...(endDate && { lte: new Date(`${endDate}T23:59:59.999Z`) }),
			},
		}),
		...(endDate && !startDate && {
			createdAt: {
				lte: new Date(`${endDate}T23:59:59.999Z`),
			},
		}),
		...(planType && {
			organization: {
				purchases: planType === "paid" 
					? {
						some: {
							type: "SUBSCRIPTION",
							status: "active",
						},
					}
					: {
						none: {
							type: "SUBSCRIPTION",
							status: "active",
						},
					},
			},
		}),
	};

	return await db.job.findMany({
		where: whereClause,
		select: {
			id: true,
			title: true,
			description: true,
			cost: true,
			costBreakDown: true,
			creditUsageStatus: true,
			status: true,
			functionName: true,
			source: true,
			errorMessage: true,
			createdAt: true,
			user: {
				select: {
					id: true,
					name: true,
					email: true,
					image: true,
				},
			},
			organization: {
				select: {
					id: true,
					name: true,
					slug: true,
					purchases: {
						select: {
							type: true,
							status: true,
						},
					},
				},
			},
			key: {
				select: {
					id: true,
					name: true,
				},
			},
			video: {
				select: {
					id: true,
					title: true,
					videoLength: true,
					status: true,
					statusHistory: true,
				},
			},
			startTime: true,
			endTime: true,
		},
		take: limit,
		skip: offset,
		orderBy: { createdAt: "desc" },
	});
}

export async function countAllJobs({
	query,
	status,
	organizationId,
	startDate,
	endDate,
	planType,
}: {
	query?: string;
	status?: string;
	organizationId?: string;
	startDate?: string;
	endDate?: string;
	planType?: "free" | "paid";
} = {}) {
	const whereClause: any = {
		isDeleted: false,
		...(query && {
			OR: [
				{
					title: {
						contains: query,
						mode: "insensitive",
					},
				},
				{
					description: {
						contains: query,
						mode: "insensitive",
					},
				},
				{
					user: {
						email: {
							contains: query,
							mode: "insensitive",
						},
					},
				},
				{
					organization: {
						name: {
							contains: query,
							mode: "insensitive",
						},
					},
				},
			],
		}),
		...(status && { status: status as any }),
		...(organizationId && { organizationId }),
		...(startDate && {
			createdAt: {
				gte: new Date(`${startDate}T00:00:00.000Z`),
				...(endDate && { lte: new Date(`${endDate}T23:59:59.999Z`) }),
			},
		}),
		...(endDate && !startDate && {
			createdAt: {
				lte: new Date(`${endDate}T23:59:59.999Z`),
			},
		}),
		...(planType && {
			organization: {
				purchases: planType === "paid" 
					? {
						some: {
							type: "SUBSCRIPTION",
							status: "active",
						},
					}
					: {
						none: {
							type: "SUBSCRIPTION",
							status: "active",
						},
					},
			},
		}),
	};

	return await db.job.count({
		where: whereClause,
	});
}

export async function getJobById(id: string) {
	return await db.job.findUnique({
		where: { id, isDeleted: false },
		select: {
			id: true,
			title: true,
			description: true,
			cost: true,
			costBreakDown: true,
			creditUsageStatus: true,
			status: true,
			functionName: true,
			source: true,
			errorMessage: true,
			webhook: true,
			createdAt: true,
			user: {
				select: {
					id: true,
					name: true,
					email: true,
					image: true,
				},
			},
			organization: {
				select: {
					id: true,
					name: true,
					slug: true,
					purchases: {
						select: {
							type: true,
							status: true,
						},
					},
				},
			},
			key: {
				select: {
					id: true,
					name: true,
				},
			},
			video: {
				select: {
					id: true,
					title: true,
					videoLength: true,
					status: true,
					shorts: true,
				},
			},
			files: {
				select: {
					id: true,
					name: true,
					type: true,
					size: true,
					status: true,
				},
			},
		},
	});
}
